// @flow
import gql from 'graphql-tag';
import React from 'react';
import FooterSeoLinks from '@homeaway/react-footer-seo-links';
import withLingua from '../withLingua/withLingua';

import type {DestinationShape} from '../../queries/searchQuery';
import type {LinguaProps} from '../withLingua/withLingua';

export const fragments = {
    results: gql`
        fragment FooterSeoLinksResults on Results {
            destination {
                breadcrumbs {
                    name
                    url
                }
                links {
                    name
                    url
                }
            }
        }
    `
};

type OwnProps = {
    destination: DestinationShape
};

const linkMapper = ({name, url}) => ({
    url,
    text: name
});

type Props = OwnProps & LinguaProps;

const ConnectedFooterSeoLinks = ({
    destination,
    messages,
    isLinguaLoading
}: Props) => {
    if (!isLinguaLoading) {
        // Footer SEO Links
        const categories = [];

        const {
            breadcrumbs: destinationBreadcrumbs,
            links: destinationLinks
        } = destination;

        if (destinationBreadcrumbs) {
            categories.push({
                isBreadcrumbs: true,
                links: destinationBreadcrumbs.map(linkMapper)
            });
        }

        if (destinationLinks) {
            categories.push({
                links: destinationLinks.map(linkMapper)
            });
        }

        return (
            <FooterSeoLinks
                categories={categories}
                panelTitle={messages.seoLinksTitle}
            />
        );
    }
    return null;
};

export default withLingua({
    namespace: 'traveler/listing',
    category: 'messages'
})(ConnectedFooterSeoLinks);
